export const API_URL = 'https://vendas.uniodontomaceio.com.br/vendas-servidor';
//export const API_URL = 'http://localhost:3001';